import { TypeaheadResultsItem } from 'foundations-components/transitional/components/Typeahead';
import { jsx as _jsx } from "react/jsx-runtime";
export const SearchAutocompleteResultItem = ({
  option,
  index,
  highlightedOptionIndex,
  onResultItemMouseEnter,
  onResultItemClick,
  itemComponent
}) => {
  return /*#__PURE__*/_jsx(TypeaheadResultsItem, {
    highlighted: highlightedOptionIndex === index,
    itemComponent: itemComponent,
    onClick: () => {
      onResultItemClick(option, index);
    },
    onMouseEnter: () => {
      onResultItemMouseEnter(option, index);
    },
    option: option
  });
};